import React, { Fragment } from 'react';
import { withSize } from 'react-sizeme';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import useCsvData from '~/kits/general/scripts/hooks/useCsvData';
import ChartWrapper from '~/core/scripts/chart-components/ChartWrapper';
import XAxis from '~/core/scripts/chart-components/XAxis';
import YAxis from '~/core/scripts/chart-components/YAxis';
import Grid from '~/core/scripts/chart-components/Grid';
import d3 from '../Chart/d3';
import labels from './labels';

const isSmallScreen = !is768Query();
const margin = {
  top: 20,
  left: 0,
  right: 25,
  bottom: 0
};
const xTicks = [2013, 2014, 2015, 2016, 2017, 2018, 2019].map(value => ({ value: new Date(value, 0, 1), label: value }));
const yTicks = [0, 5, 10, 15, 20, 25].map(value => ({ value, label: value }));
const yTicksGrid = [0, 2.5, 5, 7.5, 10, 12.5, 15, 17.5, 20, 22.5, 25].map(value => ({ value, label: value }));

const parseRow = r => {
  const splittedDate = r.date.split('-');

  return {
    date: new Date(splittedDate[0], +splittedDate[1] - 1, splittedDate[2]),
    value: +r.value
  };
};

export default withSize()(({ size }) => {
  const loessData = useCsvData('loess_afd.csv', parseRow);
  const eastData = useCsvData('ost.csv', parseRow);
  const westData = useCsvData('west.csv', parseRow);

  const { width } = size;
  const height = isSmallScreen ? width * 0.6 : width * 0.7;

  if (!loessData || !eastData || !westData) {
    return false;
  }

  const xScale = d3.scaleLinear()
    .domain([new Date(2013, 0, 1), new Date(2019, 7, 26)])
    .range([margin.left, width - margin.right]);

  const yScale = d3.scaleLinear()
    .domain([0, 25])
    .range([height - margin.bottom, margin.top]);

  const line = d3.line()
    .x(d => xScale(d.date))
    .y(d => yScale(d.value));

  return (
    <Fragment>
      <ChartWrapper
        width={width}
        height={height}
      >
        <XAxis
          margin={margin}
          width={width}
          height={height}
          ticks={xTicks}
          x={xScale}
        />
        <YAxis
          margin={margin}
          width={width}
          height={height}
          ticks={yTicks}
          y={yScale}
          unit="%"
        />
        <Grid
          margin={margin}
          width={width}
          height={height}
          y={yScale}
          x={xScale}
          values={{
            x: xTicks,
            y: yTicksGrid
          }}
        />
        <path
          d={line(loessData)}
          className="chart__line avg"
        />
        <path
          d={line(eastData)}
          className="chart__line east"
        />
        <path
          d={line(westData)}
          className="chart__line west"
        />
      </ChartWrapper>
      {labels.map(l => (
        <div
          key={`label__${l.label}`}
          className={`chart__label ${l.class}`}
          style={{
            left: xScale(isSmallScreen ? l.xMobile : l.x),
            top: yScale(isSmallScreen ? l.yMobile : l.y),
            ...l.style
          }}
        >
          {l.label}
        </div>
      ))}
    </Fragment>
  );
});
